import './bootstrap';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  // BrowserView,
  // MobileView,
  // isBrowser,
  isMobile,
} from 'react-device-detect';
import './index.scss';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { ConfigProvider } from 'antd';
import viVN from 'antd/lib/locale/vi_VN';
import enUS from 'antd/lib/locale/en_US';
import * as serviceWorker from './serviceWorker';
// common scss
import './scss/icomoon.scss';
import './scss/common.scss';
import App from './App';

// redux
import allReducers from './redux/reducers';
// redux saga
import rootSaga from './redux/sagas/root_saga';
import MobileComponent from './components/web_mobile/MobileComponent';

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
  : compose;

const store = createStore(
  allReducers,
  composeEnhancers(applyMiddleware(sagaMiddleware)),
);
sagaMiddleware.run(rootSaga);

store.dispatch({
  type: '@@__INIT__',
});

window.dispatch = store.dispatch;

ReactDOM.render(
  <Provider store={store}>
    {/* <ConfigProvider locale={viVN}> */}
    { isMobile ? <MobileComponent /> : <App /> }
    {/* </ConfigProvider> */}
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
